import { REG_TYPE_ID, REMOVE_REG_TYPE_ID } from '../actions/regTypeId';


export default (state = {}, action) => {
    switch (action.type) {
        case REG_TYPE_ID:
          state[action.payload.key] = action.payload.id;
          return {...state}

        case REMOVE_REG_TYPE_ID:
          delete state[action.payload.key];
          return {...state};

        default: return state;
    }
}
